import type { ComponentType } from 'react';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export function getDisplayName(WrappedComponent: ComponentType<any>) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
